module.exports = {BOPLocationsAndBuildingsPage:{content:[{entityType:'entity.BOPBuilding'}]}}